import React from 'react';
import { SITE } from '../../mock';

export default function TopBar() {
  return (
    <div className="w-full bg-gradient-to-r from-amber-200 via-amber-300 to-amber-200 text-neutral-900">
      <div className="max-w-7xl mx-auto px-6 py-2 text-center text-[12px] md:text-[13px] font-medium tracking-wide">
        <a href="#program" className="hover:underline underline-offset-4">
          {SITE.topBar}
        </a>
      </div>
    </div>
  );
}
